export const BROWSER_APM_APP = "lumi-dashboard";
export const BROWSER_APM_NAMESPACE = "team-esyfo";
export const BROWSER_SESSION_SAMPLING_RATE = 1;
export const UNKNOWN_PAGE_ID = "/{unknown}";
